import React from 'react';
import { Alert, AlertTitle, Button, Box } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

const SessionWarning = () => {
  const { error, clearError, logout } = useAuth();

  // Only show if error contains session/expiry related message
  if (!error || (!error.toLowerCase().includes('session') && !error.toLowerCase().includes('expire'))) {
    return null;
  }

  const handleSignOut = () => {
    logout();
  };

  const handleDismiss = () => {
    clearError();
  };

  return (
    <Alert 
      severity="warning" 
      sx={{ 
        position: 'fixed', 
        top: 16, 
        right: 16, 
        zIndex: 9999,
        minWidth: 350,
        maxWidth: 450,
        boxShadow: 3,
        border: '2px solid #ed6c02',
        animation: 'pulse 2s infinite'
      }}
      action={
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button color="inherit" size="small" onClick={handleDismiss}>
            Dismiss
          </Button>
          <Button color="inherit" size="small" onClick={handleSignOut} variant="outlined">
            Sign Out
          </Button>
        </Box>
      }
    >
      <AlertTitle>Session Warning</AlertTitle>
      {error}
    </Alert>
  );
};

export default SessionWarning;